export default __webpack_public_path__ + "static/industry-sports-ceb700b8ffb09102346aad1a3fe625e1.png";